
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { SpecialtyItemProps } from ".";
import { loading, create } from "store/specialty";

interface ApiSpecialtyCreateInputProps extends Omit<SpecialtyItemProps, "id"> {
}

type ApiSpecialtyCreateOutputProps = OutputBaseProps<{ item: SpecialtyItemProps; }, ApiSpecialtyCreateInputProps>

export const apiSpecialtyCreate = async (data: ApiSpecialtyCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiSpecialtyCreateOutputProps>("/api/specialty/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};